module.exports = __webpack_public_path__ + "img/logo_inkoppas.653b1aa0.png";